import type {CSSProperties} from 'react';
import {radius} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBriefContactLook = 'briefcontact-row' | 'briefcontact-copy';

const BRIEF_CONTACT_LOOKS = new Set<string>(['briefcontact-row', 'briefcontact-copy']);
export const isWedgeBriefContactLook = (look: string | undefined): look is WedgeBriefContactLook => look !== undefined && BRIEF_CONTACT_LOOKS.has(look);

/* Released controls of the brief contact panel (prep-screens-2 VerifiedByGoogle). The row is the full width disclosure row (the maps toggle),
   at least 44px tall with a 12px gap, a bare fill and no border; the caller passes the padding because the panel steps it down by density.
   The copy row sits inside the maps list: 44px tall, a 10px gap, 9px and 11px of padding, the card fill, a 10px radius and no border. Both
   take the caller's ink where it differs, and the font face of the shell. Every look is 44px tall at least and spans its row, so none draws
   a transparent target (wedgeBriefContactDrawsHit). */
export const wedgeBriefContactDrawsHit = (look: string): boolean => !isWedgeBriefContactLook(look);

export function wedgeBriefContactStyle(look: WedgeBriefContactLook): CSSProperties {
  switch (look) {
    case 'briefcontact-row':
      return {
        display: 'flex', alignItems: 'center', gap: 12, minHeight: 44, width: '100%', textAlign: 'left', background: 'none', border: 'none',
        color: 'inherit', fontFamily: wedgeExactRole('font'), cursor: 'pointer',
      };
    case 'briefcontact-copy':
      return {
        display: 'flex', alignItems: 'center', gap: 10, padding: '9px 11px', minHeight: 44, borderRadius: radius.md, background: wedgeExactRole('bgElev'),
        border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer', color: wedgeExactRole('label'), fontFamily: wedgeExactRole('font'),
      };
  }
}
